import React from "react";
import "./About.css";

const About = () => {
  return (
    <section id="about" className="about">
      <div className="container">
        <div className="about-content">
          <div className="about-text">
            <h2>About Nanglo Momos & Curry</h2>
            <p>
              Part of the Himalayan Yak Group, we bring you the most authentic
              Indian and Nepali fast food experience. Our chefs prepare
              traditional recipes passed down through generations, using fresh
              ingredients and authentic spices.
            </p>
            <p>
              Located in the heart of Sheboygan, we're proud to serve our
              community with delicious momos, flavorful curries, and traditional
              Himalayan dishes that will transport you to the mountains.
            </p>
          </div>
          <div className="about-image">
            <div className="image-placeholder">
              <i className="fas fa-utensils"></i>
              <p>Authentic Himalayan Cuisine</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
